import { HoverInfo, NeutralTag } from "@certn/cascadia-react";
import { css } from "@emotion/css";

interface Props {
  tags: string[];
  capacity: number;
  hasOverflowDetails?: boolean;
  testID: string;
}
export function TagList({
  tags,
  capacity,
  hasOverflowDetails = false,
  testID,
}: Props) {
  const overflow = hasOverflowDetails ? (
    <HoverInfo
      infoContent={
        <div className={styles.tagPopupDiv}>
          {tags.slice(capacity).map((tag: string, i: number) => {
            return (
              <NeutralTag type="subtle" key={i}>
                {tag}
              </NeutralTag>
            );
          })}
        </div>
      }
      trigger={
        <NeutralTag type="subtle">+ {tags.length - capacity}</NeutralTag>
      }
      testID={`${testID}-tag-hover-info`}
    />
  ) : (
    <NeutralTag type="subtle">+ {tags.length - capacity}</NeutralTag>
  );

  return (
    <div className={styles.tags} data-testid={`${testID}-tags`}>
      {tags?.slice(0, capacity).map((tag: string, i: number) => {
        return (
          <NeutralTag type="subtle" key={i}>
            {tag}
          </NeutralTag>
        );
      })}
      {tags?.length > capacity && overflow}
    </div>
  );
}

const styles = {
  tags: css({
    display: "flex",
    gap: "var(--space-2)",
    flexWrap: "wrap",
  }),
  tagPopupDiv: css({
    display: "flex",
    flexDirection: "row",
    gap: "var(--space-2)",
    flexWrap: "wrap",
    maxWidth: 180,
  }),
};
